import React, { Component } from 'react';
import { Grid, Cell } from 'react-mdl';

class Landing extends Component {
    render() {
        return (
            <div style={{ width: '100%', margin: 'auto' }}>
                <Grid className="langing-grid">
                    <Cell col={12}>
                        <img
                            src="https://www.shareicon.net/data/128x128/2015/09/22/105500_development_512x512.png"
                            alt="avatar"
                            className="avatar-img"
                        />

                        <div className="banner-text">
                            <h1>Full Stack Web Developer</h1>

                            <hr />

                            <p>HTML/CSS | Bootstrap | JavaScript | React | NodeJS | Express | MySQL</p>

                            
                            <div className="social-links">
                                {/* Github */}
                                <a href="https://github.com/hjvasoya009" rel="noopener noreferrer" target="_blank">
                                    <i className="fa fa-github-square" aria-hidden="true"></i>
                                </a>

                                {/* Linkedin */}
                                <a href="https://www.linkedin.com/in/hjvasoya/" rel="noopener noreferrer" target="_blank">
                                    <i className="fa fa-linkedin" aria-hidden="true"></i>
                                </a>
                            </div>

                        </div>
                    </Cell>
                </Grid>
            </div>
        )
    }
}

export default Landing;